export type ViewPageExtensionsAndRendererAssetsParticipant =
	| 'content'
	| 'macro-data'
	| 'macro-ssr'
	| 'smart-links';

export type ViewPageExtensionsAndRendererAssetsParticipantStatus = {
	participant: ViewPageExtensionsAndRendererAssetsParticipant;
	status: 'scheduled' | 'skipped';
};

/**
 * Records view-page preload participation without changing task execution. This gives the route a
 * single ownership point while individual preloaders continue to own their request behaviour.
 */
export const createViewPageExtensionsAndRendererAssetsCoordinator = () => {
	const participantStatuses: ViewPageExtensionsAndRendererAssetsParticipantStatus[] = [];

	return {
		schedule: <Task>(
			participant: ViewPageExtensionsAndRendererAssetsParticipant,
			createTask: () => Promise<Task>,
		): Promise<Task> => {
			participantStatuses.push({ participant, status: 'scheduled' });

			return createTask();
		},
		skip: (participant: ViewPageExtensionsAndRendererAssetsParticipant): void => {
			participantStatuses.push({ participant, status: 'skipped' });
		},
		getParticipantStatuses: (): readonly ViewPageExtensionsAndRendererAssetsParticipantStatus[] =>
			participantStatuses,
	};
};
